import {ObjectDTO} from "../object-dto";

export class TypeUtilisateurPmsDto extends ObjectDTO {
  libelle: string;
}
